import React from 'react';

import ScrollingMarqueeList from './common';

type ScrollingTextWidgetProps = {
  texts: string[];
};
const ScrollingTextWidget: React.FC<ScrollingTextWidgetProps> = React.memo((props) => {
  const { texts } = props;
  const renderItem = (item: string) => <span className="font-light text-3xl text-purple px-10 py-2">{item}</span>;
  return (
    <div className="flex flex-col text-center">
      <ScrollingMarqueeList items={texts} renderItem={(item) => renderItem(item)} />
    </div>
  );
});
ScrollingTextWidget.displayName = 'ScrollingTextWidget';
export default ScrollingTextWidget;
